import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get, isEmpty, isNil } from 'lodash';

const useWorkflowGuard = (searchParams, navigate) => {
  const { pathname } = useLocation();
  const checkinData = useSelector((state) => state.workflow);
  const workflowUrl = get(checkinData, 'data.url', '');
  const workflowPathname = workflowUrl ? workflowUrl.split('?')[0] : '';

  useEffect(() => {
    const key = searchParams.get('key');
    if (!key) {
      navigate('/');
    } else if (isNil(checkinData) || isEmpty(checkinData)) {
      navigate(`/checkin?key=${key}`);
    }
  }, [searchParams, navigate, checkinData]);

  useEffect(() => {
    const key = searchParams.get('key');
    if (key && workflowPathname && workflowPathname !== pathname && pathname !== '/checkin') {
      navigate(`/checkin?key=${key}`, { replace: true });
    }
  }, [pathname]);
};

export default useWorkflowGuard;
